var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_delete"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 299.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432.21,236.47v247a15,15,0,0,1-15,15H179.74a15,15,0,0,1-15-15v-247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.56,182.93v1.13a32.25,32.25,0,0,1-32.26,32.25H157.73a32.25,32.25,0,0,1-32.25-32.25v-1.13a32.25,32.25,0,0,1,32.25-32.25H439.3A32.25,32.25,0,0,1,471.56,182.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 260.84,
    y: 113,
    width: 75.36,
    height: 75.36,
    rx: 37.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.42,
    y: 352.25,
    width: 173.87,
    height: 33.58,
    rx: 16.5,
    transform: "translate(600.4 137.68) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.58,
    y: 352.25,
    width: 173.87,
    height: 33.58,
    rx: 16.5,
    transform: "translate(667.56 70.52) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 278.74,
    y: 352.25,
    width: 173.87,
    height: 33.58,
    rx: 16.5,
    transform: "translate(734.71 3.36) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactDelete);
export default __webpack_public_path__ + "static/media/contact_delete.620bc37d04b3767c427cd1a4a7033bbb.svg";
export { ForwardRef as ReactComponent };